import {
    CHANGE_FIELD,
    CHANGE_QUESTION_TRIGGER,
    CHANGE_REF_SETTINGS_INFO_STATE,
    CHANGE_REFERRAL_SETTINGS_STATE,
    CHANGE_REFERRAL_TRIGGER,
    CREATED_SOLICITOR_GROUP_RESPONSE,
    FAILED_TO_GET_POLICIES,
    FAILED_TO_PATCH_POLICY_QUESTIONS_GROUP,
    FAILED_TO_RECEIVE_FILTERED_POLICY,
    LOGOUT,
    RECEIVE_BAD_REQUEST_GET_QUESTIONS,
    RECEIVE_BAD_REQUEST_POST_POLICY_RESPONSE,
    RECEIVE_FILTERED_POLICY,
    RECEIVE_APPLICATION_FORM_TEMPLATE,
    RECEIVE_GET_CASE_TYPES,
    RECEIVE_GET_POLICIES,
    RECEIVE_GET_QUESTIONS,
    RECEIVE_GET_SOLICITORS_SOLICITOR_GROUP,
    RECEIVE_PATCH_POLICY_QUESTIONS_GROUP,
    RECEIVE_POST_POLICY_RESPONSE,
    RECEIVE_SOLICITOR_GROUP_CASE_TYPES,
    RECEIVE_SOLICITOR_GROUPS,
    RECEIVE_SUB_CASE_TYPES,
    REQUEST_FILTERED_POLICY,
    REQUEST_GET_QUESTIONS,
    REQUEST_PATCH_POLICY_QUESTIONS_GROUP,
    REQUEST_POST_POLICY
} from "../actions/index";
import _ from 'lodash';
import {
    CHANGE_KEYWORD_ADDITION_FORM,
    CHANGE_KEYWORD_ADDITION_FORM_REFFERER,
    CLOSE_CASE_REFERRAL_KEYWORD_ADDITION_MODAL,
    CREATE_CASE_REFERRAL_KEYWORD,
    CREATE_CASE_REFERRAL_KEYWORD_AND_ADD_ANOTHER,
    CREATE_CASE_REFERRAL_KEYWORD_FAIL,
    CREATE_CASE_REFERRAL_KEYWORD_SUCCESS,
    GET_CASE_REFERRAL_KEYWORDS,
    GET_CASE_REFERRAL_KEYWORDS_FAIL,
    GET_CASE_REFERRAL_KEYWORDS_SUCCESS,
    OPEN_CASE_REFERRAL_KEYWORD_ADDITION_MODAL
} from "../actions";

const calculateTriggerValues = (policy, defaultQuestionTriggers) => {
    let trigg = defaultQuestionTriggers;
    let tId;
    if (policy.questionsTriggers.length > 0) {
        for (let j = 0; j < policy.questionsTriggers.length; j++) {
            tId = policy.questionsTriggers[j].questionId;
            trigg = {
                ...trigg,
                [tId]: {
                    medical: policy.questionsTriggers[j].medical,
                    tuw: policy.questionsTriggers[j].tuw,
                    cmu: policy.questionsTriggers[j].cmu
                }
            }
        }
    }
    return trigg
};

const defaultState = {
    solicitors: [],
    policies: [],
    questions: [],
    groups: [],
    caseTypes: [],
    subCaseTypes: [],
    appType: 'custom',
    selectedGroup: '',
    selectedCaseType: '',
    selectedSubCaseType: '',
    featuredQuestions: [],
    featuredQuestionsIds: [],
    openModal: false,
    showTable: false,
    msg: '',
    badMsg: '',
    questionTriggers: [],
    referralTriggers: [],
    referralTriggersSettings: [],
    defaultQuestionTriggers: [],
    posting: false,
    featuredPolicy: '',
    viewSolicitors: false,
    fetching: false,
    badFetchResponse: '',
    questionsForTriggers: [],
    infoState: {},
    patchingQuestionsGroup: false,
    failedToGetPoliciesMsg: '',
    fetchingFilteredPolicy: false,
    caseReferralKeywordAdditionModalOpen: false,
    keywordAdditionForm: {
        referredToMedicalExpert: false,
        referredToTechnicalUnderwriter: false,
        referredToUnderwriter: false,
        keyword: ''
    },
    postingCaseReferralKeyword: false,
    createCaseReferralKeywordErrorMessage: '',
    addAnotherKeywordAfterCreation: false,
    fetchingCaseReferralKeywords: false,
    caseReferralKeywords: []
};

export default (state = defaultState, action) => {
    switch (action.type) {
        case GET_CASE_REFERRAL_KEYWORDS:
            return {
                ...state,
                fetchingCaseReferralKeywords: true
            };
        case GET_CASE_REFERRAL_KEYWORDS_SUCCESS:
            return {
                ...state,
                fetchingCaseReferralKeywords: false
            };
        case GET_CASE_REFERRAL_KEYWORDS_FAIL:
            return {
                ...state,
                fetchingCaseReferralKeywords: false
            };
        case CREATE_CASE_REFERRAL_KEYWORD_AND_ADD_ANOTHER:
            return {
                ...state,
                postingCaseReferralKeyword: true,
                createCaseReferralKeywordErrorMessage: defaultState.createCaseReferralKeywordErrorMessage,
                addAnotherKeywordAfterCreation: true
            };
        case CREATE_CASE_REFERRAL_KEYWORD:
            return {
                ...state,
                postingCaseReferralKeyword: true,
                createCaseReferralKeywordErrorMessage: defaultState.createCaseReferralKeywordErrorMessage,
                addAnotherKeywordAfterCreation: false
            };
        case CREATE_CASE_REFERRAL_KEYWORD_SUCCESS:
            return {
                ...state,
                postingCaseReferralKeyword: false,
                keywordAdditionForm: defaultState.keywordAdditionForm,
                caseReferralKeywordAdditionModalOpen: state.addAnotherKeywordAfterCreation,
                addAnotherKeywordAfterCreation: defaultState.addAnotherKeywordAfterCreation
            };
        case CREATE_CASE_REFERRAL_KEYWORD_FAIL:
            let createCaseReferralKeywordErrorMsg = '';
            try {
                createCaseReferralKeywordErrorMsg = action.payload.response.body.message
            } catch (e) {
                createCaseReferralKeywordErrorMsg = 'Failed to create case referral keyword.'
            }
            return {
                ...state,
                postingCaseReferralKeyword: false,
                createCaseReferralKeywordErrorMessage: createCaseReferralKeywordErrorMsg
            };
        case CHANGE_KEYWORD_ADDITION_FORM_REFFERER:
            if(action.payload.key === 'referredToMedicalExpert') {
                return {
                    ...state,
                   keywordAdditionForm: {
                       referredToMedicalExpert: action.payload.value,
                       referredToTechnicalUnderwriter: false,
                       referredToUnderwriter: false,
                   },
                    createCaseReferralKeywordErrorMessage: defaultState.createCaseReferralKeywordErrorMessage
                }
            } else if(action.payload.key === 'referredToTechnicalUnderwriter') {
                return {
                    ...state,
                    keywordAdditionForm: {
                        referredToMedicalExpert: false,
                        referredToTechnicalUnderwriter:  action.payload.value,
                        referredToUnderwriter: false,
                    },
                    createCaseReferralKeywordErrorMessage: defaultState.createCaseReferralKeywordErrorMessage
                }
            }  else if(action.payload.key === 'referredToUnderwriter') {
                return {
                    ...state,
                    keywordAdditionForm: {
                        referredToMedicalExpert: false,
                        referredToTechnicalUnderwriter:  false,
                        referredToUnderwriter: action.payload.value,
                    },
                    createCaseReferralKeywordErrorMessage: defaultState.createCaseReferralKeywordErrorMessage
                }
            } else {
                return {
                    ...state,
                    createCaseReferralKeywordErrorMessage: defaultState.createCaseReferralKeywordErrorMessage
                };
            }
        case CHANGE_KEYWORD_ADDITION_FORM:
            return {
                ...state,
                keywordAdditionForm: {
                    ...state.keywordAdditionForm,
                    [action.payload.key]: action.payload.value
                },
                createCaseReferralKeywordErrorMessage: defaultState.createCaseReferralKeywordErrorMessage
            };
        case OPEN_CASE_REFERRAL_KEYWORD_ADDITION_MODAL:
            return {
                ...state,
                caseReferralKeywordAdditionModalOpen: true
            };
        case CLOSE_CASE_REFERRAL_KEYWORD_ADDITION_MODAL:
            return {
                ...state,
                caseReferralKeywordAdditionModalOpen: false,
                keywordAdditionForm: defaultState.keywordAdditionForm,
                createCaseReferralKeywordErrorMessage: defaultState.createCaseReferralKeywordErrorMessage
            };
        case CHANGE_REFERRAL_SETTINGS_STATE:
            return {
                ...state,
                [action.payload.key]: action.payload.value
            };
        case RECEIVE_SOLICITOR_GROUP_CASE_TYPES:
            let sc = [];
            _.forEach(action.payload, cType => {
                _.forEach(cType.subCaseTypes, sCase => {
                    sc.push(sCase)
                })
            });
            return {
                ...state,
                caseTypes: action.payload,
                subCaseTypes: sc
            };
        case REQUEST_FILTERED_POLICY:
            return {
                ...state,
                fetchingFilteredPolicy: true,
                referralTriggersSettings: []
            };
        case RECEIVE_FILTERED_POLICY:
            let featuredQuestionsIds = [];
            // Merge template defaults already in state with saved values from the policy payload.
            // Merge order-independent: this case and RECEIVE_APPLICATION_FORM_TEMPLATE can arrive in either
            // order; both preserve saved values and only fill gaps with template defaults.            
            const savedRefTriggers = action.payload && action.payload.referralTriggersSettings ? action.payload.referralTriggersSettings : [];
            const refTriggersByType = new Map(state.referralTriggersSettings.map(t => [t.conditionType, t]));
            savedRefTriggers.forEach(saved => refTriggersByType.set(saved.conditionType, saved));
            let refTriggers = Array.from(refTriggersByType.values());
            let trigg = action.payload?calculateTriggerValues(action.payload, state.defaultQuestionTriggers):state.defaultQuestionTriggers;
            if(action.payload){
                _.forEach(action.payload.questionIds, item => {
                    featuredQuestionsIds.push(item);
                });
            }
            let featuredQest = [];
            if (featuredQuestionsIds.length > 0) {
                for (let i = 0; i < featuredQuestionsIds.length; i++) {
                    for (let j = 0; j < state.questions.length; j++) {
                        if (featuredQuestionsIds[i] === state.questions[j].id) {
                            featuredQest.push(state.questions[j])
                        }
                    }
                }
            }
            let questionsForTrigg = [];
            for(let index in trigg){
                if(trigg[index].medical !== '' || (trigg[index].tuw !== '') || (trigg[index].cmu !== '')){
                    for (let i = 0; i < state.questions.length; i++){
                        if(state.questions[i].id === parseInt(index)){
                            questionsForTrigg.push(state.questions[i]);

                            for (let ii = 0; ii < state.questions[i].options.length; ii++) {
                                if (state.questions[i].options[ii].childQuestions !== null) {
                                    let childQuestions = state.questions[i].options[ii].childQuestions;
                                    for (let j = 0; j < childQuestions.length; j++) {
                                        questionsForTrigg.push(childQuestions[j])
                                    }
                                }
                            }
                        }
                    }
                }
            }
            return {
                ...state,
                fetchingFilteredPolicy: false,
                featuredPolicy: action.payload,
                questionTriggers: trigg,
                featuredQuestions: featuredQest,
                featuredQuestionsIds: featuredQuestionsIds,
                referralTriggersSettings: refTriggers,
                questionsForTriggers: [],
                showTable: true
            };
        case RECEIVE_APPLICATION_FORM_TEMPLATE:
            if (!action.payload) {
                return state;
            }
            // Preserve any saved values already loaded by RECEIVE_FILTERED_POLICY; only the
            // unmatched conditionTypes get filled with the template default.
            const existingByType = new Map(state.referralTriggersSettings.map(o => [o.conditionType, o]));
            let referralTriggers = [];
            _.forEach(action.payload, item => {
                referralTriggers.push(existingByType.get(item.conditionType) || item);
            });
            return {
                ...state,
                referralTriggersSettings: referralTriggers,
            };
        case FAILED_TO_RECEIVE_FILTERED_POLICY:
            return {
                ...state,
                fetchingFilteredPolicy: false
            };
        case REQUEST_PATCH_POLICY_QUESTIONS_GROUP:
            return {
                ...state,
                patchingQuestionsGroup: true
            };
        case RECEIVE_PATCH_POLICY_QUESTIONS_GROUP:
            return {
                ...state,
                patchingQuestionsGroup: false
            };
        case FAILED_TO_PATCH_POLICY_QUESTIONS_GROUP:
            return {
                ...state,
                patchingQuestionsGroup: false,
                badMsg: 'Failed to update group order. Please refresh and try again later.'
            };
        case CHANGE_REF_SETTINGS_INFO_STATE:
            return {
                ...state,
                infoState: {...state.infoState, [action.payload]: !state.infoState[action.payload]}
            };
        case RECEIVE_GET_POLICIES:
            return {
                ...state,
                policies: action.payload
            };
        case FAILED_TO_GET_POLICIES:
            return {
                ...state,
                failedToGetPoliciesMsg: 'Failed to get policies. Please try again later.'
            };
        case REQUEST_GET_QUESTIONS:
            return {
                ...state,
                fetching: true
            };
        case RECEIVE_BAD_REQUEST_GET_QUESTIONS:
            return {
                ...state,
                fetching: false,
                badFetchResponse: action.payload
            };
        case RECEIVE_GET_QUESTIONS:
            let questionsInOrder = [];
            let triggers = state.questionTriggers;
            let defaultTriggers = {};
            let id;
            let featuredQuestions = [];
            let infoState = {};
            for (let i = 0; i < action.payload.length; i++) {
                id = action.payload[i].id;
                defaultTriggers = {...defaultTriggers, [id]: {medical: '', tuw: '', cmu: ''}};
                if (state.questionTriggers[id])
                    continue;
                triggers = {...triggers, [id]: {medical: '', tuw: '', cmu: ''}}
            }
            for (let i = 0; i < state.featuredQuestionsIds.length; i++) {
                for (let j = 0; j < action.payload.length; j++) {
                    if (state.featuredQuestionsIds[i] === action.payload[j].id) {
                        featuredQuestions.push(action.payload[j])
                    }
                }
            }
            for (let i = 0; i < action.payload.length; i++) {
                if (action.payload[i].isParent) {
                    questionsInOrder.push(action.payload[i]);
                    //below if statement is adding another object to the the info table in order to display the infos
                    //of the referral table
                    if (action.payload[i].tooltip) {
                        infoState = {...infoState, [action.payload[i].id]: false};
                    }
                    if (action.payload[i].options !== null) {
                        for (let k = 0; k < action.payload[i].options.length; k++) {
                            for (let j = 0; j < action.payload[i].options[k].childQuestions.length; j++) {
                                questionsInOrder.push(action.payload[i].options[k].childQuestions[j]);
                                //below if statement is adding another object to the the info table in order to display the infos
                                //of the referral table
                                if (action.payload[i].options[k].childQuestions[j].tooltip) {
                                    infoState = {
                                        ...infoState,
                                        [action.payload[i].options[k].childQuestions[j].id]: false
                                    };
                                }
                                //if child question has child questions we must add also these questions to the store
                                if (action.payload[i].options[k].childQuestions[j].options !== null) {
                                    let childQuestion = action.payload[i].options[k].childQuestions[j];
                                    if (action.payload[i].options[k].childQuestions[j].options.length > 0) {
                                    }
                                    for (let r = 0; r < childQuestion.options.length; r++) {
                                        for (let l = 0; l < childQuestion.options[r].childQuestions.length; l++) {
                                            questionsInOrder.push(childQuestion.options[r].childQuestions[l])
                                   //below grand child is handled
                                            if (childQuestion.options[r].childQuestions[l].options.length > 0) {
                                                for (let a = 0; a < childQuestion.options[r].childQuestions[l].options.length; a++) {
                                                    if (childQuestion.options[r].childQuestions[l].options[a].childQuestions.length > 0) {
                                                        for (let b = 0; b < childQuestion.options[r].childQuestions[l].options[a].childQuestions.length; b++) {
                                                            questionsInOrder.push(childQuestion.options[r].childQuestions[l].options[a].childQuestions[b])
                                                        }
                                                    }
                                                }
                                            }

                                    //below if statement is adding another object to the the info table in order to display the infos
                                            //of the referral table
                                            if (childQuestion.options[r].childQuestions[l].tooltip) {
                                                infoState = {
                                                    ...infoState,
                                                    [childQuestion.options[r].childQuestions[l].id]: false
                                                };
                                            }
                                        }
                                    }
                                }
                            }
                        }
                    }
                }
            }
            return {
                ...state,
                questions: _.uniqBy(questionsInOrder, 'id'),
                questionTriggers: triggers,
                defaultQuestionTriggers: defaultTriggers,
                featuredQuestions: featuredQuestions,
                fetching: false,
                infoState: infoState
            };
        case RECEIVE_SOLICITOR_GROUPS:
            return {
                ...state,
                groups: action.payload.data
            };
        case RECEIVE_GET_CASE_TYPES:
            return {
                ...state,
                caseTypes: action.payload
            };
        case CHANGE_FIELD:
            if (action.payload.key === 'selectedGroup') {
                let groups = state.groups;
                let caseTypes = [];
                let subCaseTypes = [];
                if(action.payload.value){
                    caseTypes = _.find(groups, item => item.id.toString() === action.payload.value).caseTypes;
                    // subCaseTypes ;
                    if (caseTypes)
                        _.forEach(caseTypes, (caseType => {
                            let sCase = [];
                            _.forEach(caseType.subCaseTypes, item => {
                               sCase.push({...item, caseTypeId: caseType.id})
                            });
                            subCaseTypes = [...subCaseTypes, ...sCase]
                        }));

                }
                return {
                    ...state,
                    [action.payload.key]: action.payload.value,
                    featuredQuestions: [],
                    featuredQuestionsIds: [],
                    showTable: false,
                    msg: '',
                    badMsg: '',
                    selectedCaseType: action.payload.value? state.selectedCaseType: '',
                    selectedSubCaseType: '',
                    featuredPolicy: '',
                    caseTypes: caseTypes ? caseTypes : [],
                    subCaseTypes: subCaseTypes ? subCaseTypes : []
                }
            }
            if (action.payload.value === 'custom' || (action.payload.value === 'default') ||
                (action.payload.value === 'caseReferralKeywords') )
                return {
                    ...state,
                    [action.payload.key]: action.payload.value,
                    selectedGroup: '',
                    selectedCaseType: '',
                    selectedSubCaseType: '',
                    featuredQuestions: [],
                    featuredQuestionsIds: [],
                    showTable: false,
                    msg: '',
                    badMsg: '',
                    questionTriggers: state.defaultQuestionTriggers,
                    featuredPolicy: ''
                };
            else if ( ((action.payload.key === 'selectedGroup') || (action.payload.key === 'selectedCaseType') || (action.payload.key === 'selectedSubCaseType' )))
                if (action.payload.key === 'selectedCaseType') {
                    return {
                        ...state,
                        [action.payload.key]: action.payload.value,
                        featuredQuestions: [],
                        featuredQuestionsIds: [],
                        showTable: false,
                        msg: '',
                        badMsg: '',
                        selectedSubCaseType: '',
                        featuredPolicy: ''
                    }
                }
                else
                    return {
                        ...state,
                        [action.payload.key]: action.payload.value,
                        featuredQuestions: [],
                        featuredQuestionsIds: [],
                        showTable: false,
                        msg: '',
                        badMsg: '',
                        featuredPolicy: ''
                    };
            else if ((action.payload.key === 'msg') || (action.payload.key === 'badMsg'))
                return {
                    ...state,
                    [action.payload.key]: action.payload.value,
                };
            return {
                ...state,
                [action.payload.key]: action.payload.value,
                msg: '',
                badMsg: ''
            };
        case RECEIVE_SUB_CASE_TYPES:
            return {
                ...state,
                subCaseTypes: action.payload
            };
        case LOGOUT:
            return {
                ...defaultState
            };
        case RECEIVE_BAD_REQUEST_POST_POLICY_RESPONSE:
            return {
                ...state,
                badMsg: action.payload,
                posting: false
            };
        case CHANGE_QUESTION_TRIGGER:
            let questionsForTriggers = [...state.questionsForTriggers];
            let questionIndex = _.findIndex(questionsForTriggers, x => x.id == action.payload.key);
            if (questionIndex < 0) {
                questionsForTriggers.push(action.payload.question);
            }
            return {
                ...state,
                questionTriggers: {
                    ...state.questionTriggers,
                    [action.payload.key]: {
                        ...state.questionTriggers[action.payload.key],
                        [action.payload.triggerKey]: action.payload.value
                    }
                },
                questionsForTriggers: questionsForTriggers
            };

        case CHANGE_REFERRAL_TRIGGER:
            let referralTriggersSettings = [...state.referralTriggersSettings];
            let trigger = _.find(referralTriggersSettings, x => x.conditionType == action.payload.refTriggerSetting.conditionType);
            if (!trigger) {
                referralTriggersSettings.push({
                conditionType:action.payload.refTriggerSetting.conditionType,
                    referTo: action.payload.refTriggerSetting.referTo});
            }
            else {
                referralTriggersSettings.map(obj=>
                {
                    if( trigger.conditionType === obj.conditionType){
                        obj.referTo = action.payload.refTriggerSetting.referTo;
                        return obj;
                    }
                    return {...obj}
            })}

            return {
                ...state,
                referralTriggersSettings: referralTriggersSettings
            };

        case RECEIVE_POST_POLICY_RESPONSE:
            return {
                ...state,
                selectedGroup: '',
                selectedCaseType: '',
                selectedSubCaseType: '',
                featuredQuestions: [],
                featuredQuestionsIds: [],
                showTable: false,
                msg: 'Application Form And Referral Settings Created.',
                posting: false,
                questionTriggers: defaultState.questionTriggers,
                questionsForTriggers: defaultState.questionsForTriggers,
                featuredPolicy: defaultState.featuredPolicy,
                infoState: defaultState.infoState


            };
        case REQUEST_POST_POLICY:
            return {
                ...state,
                posting: true,
                badMsg: defaultState.badMsg
            };
        case RECEIVE_GET_SOLICITORS_SOLICITOR_GROUP:
            return {
                ...state,
                solicitors: action.payload
            };
        case CREATED_SOLICITOR_GROUP_RESPONSE:
            return {
                ...state,
                openModal: false
            };
        case '@@router/LOCATION_CHANGE':
            return {
                ...defaultState
            };
        default:
            return state
    }
}
